// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"195":"24a5da36","569":"0cf320a9","666":"c2618e5f"}[chunkId] + ".css";
};